var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    fillRule: "evenodd",
    height: 512,
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 2.54 2.54",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u56FE\\u5C42_x0020_1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.27,
    cy: 1.27,
    fill: "#00ba00",
    r: 1.27
  }), /*#__PURE__*/React.createElement("path", {
    d: "m.87344 1.88938-.46448-.49713c-.06359-.06806-.05994-.17574.00812-.23933.06806-.06359.17574-.05993.23933.00812l.35828.38346.56711-.52987c.0051-.00477.01043-.00914.01594-.01316l.26669-.24917c.06806-.06359.17575-.05993.23933.00813.06359.06805.05993.17574-.00812.23933l-.81454.76105-.00087-.00093-.28176.26326-.12503-.13382z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.9d81d365ec3fb672a321dd8f07672300.svg";
export { ForwardRef as ReactComponent };